import map from 'lodash/map'
import React, { FC, useCallback } from 'react'

import { FacetDescriptionContent } from '@Components/Facet/FacetDescription/FacetDescriptionContent'
import { FacetDescriptionOverview } from '@Components/Facet/FacetDescription/FacetDescriptionOverview'
import { NativeModal, NativeModalBody, NativeModalHeader } from '@Components/Modal/NativeModal/NativeModal'
import { useFacetDescription } from '@Globals/CMS/useFacetDescriptions'

export interface FacetDescriptionModalProps {
  facetDescriptionIDs: string[]
  setShowModal: (value: boolean) => void
  showModal: boolean
}

const facetDescriptionIDKey = 'facet_description_'

export const FacetDescriptionModal: FC<FacetDescriptionModalProps> = ({ facetDescriptionIDs, setShowModal, showModal }) => {
  const pages = useFacetDescription({ openModal: showModal, pageIDs: facetDescriptionIDs })
  const scrollToIndex = useCallback((index: number) => {
    const target = document.getElementById(facetDescriptionIDKey + index)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])
  return (
    <NativeModal defaultOpen={showModal} onClose={() => setShowModal(false)}>
      <NativeModalHeader />
      <NativeModalBody>
        {pages.length > 1 && (
          <FacetDescriptionOverview
            pages={pages}
            setIndex={scrollToIndex}
          />
        )}
        {map(pages, (page, index) => (page.blocks
                && <FacetDescriptionContent key={facetDescriptionIDKey + index} blocks={page.blocks} id={facetDescriptionIDKey + index} />))}
      </NativeModalBody>
    </NativeModal>
  )
}
